import { Grid, Typography } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { useAddressQuery } from '~/queries/useAddressQuery.ts';
import { FormRadioGroup } from '~/components/FormComponents/FormRadioGroup.tsx';
import { reasonsIdentificationNumber } from '~/modules/identification/forms/AdditionalInformation/constants.ts';
import { AddRemoveBlock } from '~/components/AddRemoveBlock/AddRemoveBlock.tsx';
import { useFormContext } from 'react-hook-form';
import { TPepEntity } from '~/modules/identification/forms/AdditionalInformation/types.ts';
import FormGridItem from '~/components/FormComponents/FormGridItem';

interface JurisdictionResidenceProps {
  parentIndex: number;
  index: number;
  add: () => void;
  remove: () => void;
  isPlusShown: boolean;
  isMinusShown: boolean;
}

export const JurisdictionResidence = ({
  parentIndex,
  index,
  add,
  remove,
  isPlusShown,
  isMinusShown,
}: JurisdictionResidenceProps) => {
  const { nonAgressionCountryOptions } = useAddressQuery();
  const { watch } = useFormContext<{ additionalInformation: TPepEntity[] }>();
  const field = `additionalInformation.${parentIndex}.jurisdictions.${index}`;
  const reason = watch(`additionalInformation.${parentIndex}.jurisdictions.${index}.reason`);
  const shouldShowExplanation = reason === 'B' || reason === 'C';

  return (
    <Grid container spacing={3}>
      <FormGridItem>
        <FormAutocomplete
          name={`${field}.country`}
          options={nonAgressionCountryOptions}
          inputProps={{
            placeholder: 'Оберіть державу / юрисдикцію',
          }}
          label="Держава / юрисдикція податкового резидентства"
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={`${field}.identifyCode`}
          label="Номер платника податків"
          placeholder="Введіть номер платника податків"
          fullWidth
        />
      </FormGridItem>
      <Typography variant="body1">
        Якщо Ви з будь-якої причини не вказуєте номер платника податків, будь ласка, зазначте
        причину
      </Typography>
      <Grid size={12}>
        <FormRadioGroup name={`${field}.reason`} options={reasonsIdentificationNumber} />
      </Grid>
      {shouldShowExplanation && (
        <Grid sx={{ width: '100%' }}>
          <FormInput
            name={`${field}.explanation`}
            label="Причина відсутності номера платника податків"
            placeholder="Введіть причину відсутності номера платника податків"
            fullWidth
          />
        </Grid>
      )}
      <AddRemoveBlock
        add={add}
        remove={remove}
        isPlusShown={isPlusShown}
        isMinusShown={isMinusShown}
        plusText='Натисніть на "+" для додавання інформації про резидентства для цілей оподаткування та відповідний номер платника податків'
        minusText='Натисніть на "-" для видалення інформації про резидентства для цілей оподаткування та відповідний номер платника податків'
      />
    </Grid>
  );
};
